import { render, staticRenderFns } from "./CasinoForm.vue?vue&type=template&id=becb4fca&"
import script from "./CasinoForm.vue?vue&type=script&lang=js&"
export * from "./CasinoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports